export const datepikerActionsTypes = {
	FILTER_DATE: 'FILTER_DATE',
};
